module.exports = __webpack_public_path__ + "static/media/sign.7d1a5c98.png";